import validateModule from 'validate.js'

const validate = (values, constraints) =>
  validateModule(values, constraints, { fullMessages: false })

export const createValidatorWithSchema = (constraints) => (values) =>
  validate(values, constraints)
